import moment from 'moment';
import constants from '@/constants';

const payments_fields = {
  '#RQ': 'id',
  'Codigo liquidacion': 'payment_code',
  'Placa': 'truck.plate',
  'Empresa de transporte': 'truck.provider.name',
  'Conductor': {
    field: 'driver',
    callback: driver => {
      return driver ? `${driver.name} ${driver.last_name}` : ''
    }
  },
  'Fecha': {
    callback: requeriment => {
      return requeriment.service.service_type.code === constants.PORTEO ? moment(requeriment.appointments[0].schedule).format('DD/MM/YYYY HH:mm') : moment(requeriment.date).format('DD/MM/YYYY HH:mm')
      //return moment(date).isValid() ? moment(date).format('DD/MM/YYYY HH:mm') : ''
    }
  },
  'Servicio': {
    field: 'service.service_type',
    callback: service_type => {
      return service_type.name
    }
  },
  'Cliente': {
    field: 'service.company',
    callback: company => {
      return company ? company.name : ''
    }
  },
  'Dirección': {
    field: 'address',
    callback: address => {
      return (address && address.place) ? `${address.alias} ${address.place.name}` : '--'
    }
  },
  'Zona': {
    field: 'address',
    callback: address => {
      return (address && address.place && address.place.zone) ? address.place.zone.name : '--'
    }
  },
  'Contenedor': {
    callback: (requirement) => {
      return requirement.service.service_type.code === constants.PORTEO ? requirement.appointments.map(ap => ap.container ? ap.container.number : '').join(', ') : requirement.container_number;
    }
  },
  'Tamaño': {
    field: 'container_size',
    callback: (container_size) => {
      return container_size ? container_size.name : ''
    }
  },
  'Deposito de retiro': {
    field: 'deposit_pick',
    callback: (deposit_pick) => {
      return deposit_pick ? deposit_pick.name : ''
    }
  },
  'Depósito de devolución (impo) o entrega Full (expo)': {
    field: 'deposit',
    callback: (deposit) => {
      return deposit ? deposit.name : ''
    }
  },
  'Resguardo': {
    callback: requeriment => {
      return requeriment.guard ? (requeriment.custody ? requeriment.custody.name : 'Si, custodia no indicada') : 'No'
    }
  },
  'Pernocte': 'overnight',
  'Descuento arrumaje': 'arr_discount',
  'Tarifa': {
    field: 'price',
    callback: price => {
      return price ? price : '--'
    }
  },
  'Moneda': {
    field: 'currency',
    callback: currency => {
      return currency ? currency.code : '--'
    }
  },
  'Kms reconocido': 'kms',
  'Galonaje reconocido': 'gallons',
  'Estado': 'status.name'
}

export default payments_fields;
